
import { EVENTS, publish } from '@nutima-themes/utils/pubsub'
import { addItem, setCartState } from '@nutima-themes/utils/cart'

(function () {

  if (window.Wishlist) return; // 🔒 tekrar yüklenirse çık

  const WISHLIST_KEY = 'wishlist_items';

  window.Wishlist = {
    get() {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    },
    set(items) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    },
    has(variantId) {
      return this.get().some(i => i.variantId === variantId);
    },
    toggle(item) {
      const items = this.get();
      const index = items.findIndex(i => i.variantId === item.variantId);

      if (index > -1) {
        items.splice(index, 1);
        this.set(items);
        return false;
      } else {
        items.push(item);
        this.set(items);
        return true;
      }
    },

    remove(variantId) {
      this.set(this.get().filter(i => i.variantId !== variantId));
    }
  };

  // 🔁 Sayfa yüklenince aktifleri işaretle
  // document.addEventListener('DOMContentLoaded', () => {
  //   document.querySelectorAll('.wishlist-btn').forEach(btn => {
  //     const variantId = Number(btn.dataset.variantId);
  //     if (window.Wishlist.has(variantId)) {
  //       btn.classList.add('active');
  //     }
  //   });
  //   updateWishlistHeader();
  // });

  // ❤️ Toggle
  document.addEventListener('click', e => {
    const btn = e.target.closest('.wishlist-btn');

    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const product = JSON.parse(btn.dataset.product);
    let variantId = Number(btn.dataset.variantId);
    const plpProductTitle = btn.dataset.plpProductTitle?.trim() || '';
    const kumas = btn.dataset.kumas?.trim() || '';

    product.plpProductTitle = plpProductTitle;
    product.kumas = kumas;
    
    const customBundleData = window.getCustomBundleData !== undefined && window.getCustomBundleData();
    const currentBundle = customBundleData[variantId]

    let urlVariantId = '';
    if(!btn.classList.value.includes('living')){
      urlVariantId = variantId
    }

    const isPageProduct = document.getElementsByTagName('body')[0].className.includes('template-product');
    if(isPageProduct){

    if (urlVariantId) {
      variantId = parseInt(urlVariantId);
      const result =
        [...document.querySelectorAll('.product-form__selected-value')]
          .map(x =>
            x.innerText
              .trim()
              .replace(/^[-–—]\s*/, '') // BAŞTAKİ "-" TEMİZLİĞİ BURADA
          )
          .filter(Boolean)
          .join(' / ');
      console.log(result)
      product.variantTitle = result === '' ? getConfgTitle() : result;
      const configuratorPageImg =
        document.querySelector(
          '#shopify-section-product-template-configurator sugar-configurator-viewer'
        ) ||
        document.querySelector(
          '#shopify-section-product-template-new-configurator sugar-configurator-viewer'
        );

      const img =
        document.querySelector('.product-gallery__main-image img')?.src ||
        configuratorPageImg?.shadowRoot
          ?.querySelector('div > center > generic-slider > div:nth-child(2) > img')
          ?.src;

      product.image = img;
      // let isAvailable = '';
      // isAvailable = document.querySelectorAll('.product-btn-area > button[type="submit"]')[0].children[0] ? document.querySelectorAll('.product-btn-area > button[type="submit"]')[0].children[0].innerText : 'Tükendi';
      // product.available = isAvailable !== 'Tükendi';
    }
    }

    const active = window.Wishlist.toggle({
      ...product,
      variantId,
      currentBundle
    });

    btn.classList.toggle('active', active);

    window.updateWishlistBadge();
  });
  updateWishlistHeader()

})();

function updateWishlistHeader() {
  const countEl = document.getElementById('WishlistCount');
  const clearBtn = document.getElementById('wishlist-clear-all');

  if (!countEl || !clearBtn || !window.Wishlist) return;

  const count = Wishlist.get().length;

  countEl.textContent = `(${count} Ürün)`;
  countEl.classList.toggle('hidden', count === 0);
  clearBtn.classList.toggle('hidden', count === 0);
  window.updateWishlistBadge();
}
document.addEventListener('click', (e) => {
  const btn = e.target.closest('#wishlist-clear-all');
  if (!btn) return;

  // 🔒 Diğer click listener’ları durdur
  e.preventDefault();
  e.stopImmediatePropagation();

  const confirmed = window.confirm('Tüm favorileri silmek istiyor musun?');
  if (!confirmed) return;

  Wishlist.set([]);

  document.getElementById('wishlist-grid').innerHTML = '';
  document.getElementById('wishlist-empty').hidden = false;

  updateWishlistHeader();
});
(function () {
  if (window.__wishlistVariantWatcher) return;
  window.__wishlistVariantWatcher = true;

  let lastVariantId = null;

  setInterval(() => {
    const params = new URLSearchParams(window.location.search);
    const urlVariantId = params.get('variant');

    if (urlVariantId && urlVariantId !== lastVariantId) {
      lastVariantId = urlVariantId;

      const btn = document.querySelector(`.wishlist-btn.product-show`);
      const btnMobil = document.querySelector(`.wishlist-btn.product-show-mobil`);
      if (!btn || !btnMobil){
        console.warn('btn yok')
      }else{

        const active = window.Wishlist.has(parseInt(lastVariantId));

        btn.classList.toggle('active', active);
        btnMobil.classList.toggle('active', active);
      }
    }
  }, 300);
})();



(function () {
  /* -------------------------
     ADD TO CART (WISHLIST)
  -------------------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.wishlist-add-to-cart');
    if (!btn) return;

    // 🔥 event tamamen burada biter
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      console.warn('Variant ID yok');
      btn.dataset.loading = 'false';
      return;
    }
    // Custom Bundle verilerini al
    const product = Wishlist.get().filter(item => item.variantId === parseInt(variantId))[0]
    const currentBundle = product.currentBundle;

    try {
      // Bundle ürünleri varsa sadece bundle ürünlerini ekle (ana ürünü EKLEME)
      if (currentBundle && currentBundle.has_bundle && currentBundle.items && currentBundle.items.length > 0) {
        const items = []

        currentBundle.items.forEach(item => {
          if (item.variant_id) {
            // Quantity validasyonu
            let itemQuantity = parseInt(item.quantity, 10)
            if (isNaN(itemQuantity) || itemQuantity < 1) {
              itemQuantity = 1
            }
            items.push({
              id: parseInt(item.variant_id),
              quantity: item.quantity
            })

          }
        })

        console.log('Bundle batch ekleme - Toplam ürün:', items.length, items)
        const drawerCart = document.querySelector('n-drawer-cart')
        const sectionId = drawerCart ? drawerCart.id : null

        // cartBeforeChange event'i yayınla (loading state için)
        publish(EVENTS.cartBeforeChange, { 
          detail: { endpoint: '/cart/add.js' } 
        })

        // TEK İSTEKTE tüm ürünleri ekle
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            items,
            sections: sectionId 
          })
        })

        if (!addResponse.ok) {
          const errorData = await addResponse.json()
          throw new Error(errorData.description || 'Sepete ekleme hatası')
        }

        // Response'tan cart ve sections bilgisini al
        const cartAddResult = await addResponse.json()

        // Cart state'i al (doğru item_count için gerekli)
        const cartResponse = await fetch('/cart.js')
        const cartState = await cartResponse.json()
        setCartState(cartState)

        // Cart change event'i yayınla - sections + doğru cartState
        publish(EVENTS.cartChange, { 
          detail: { 
            endpoint: '/cart/add.js',
            cart: {
              ...cartState,
              sections: cartAddResult.sections
            },
            cartState: cartState
          } 
        })
      } else {
        // Bundle yoksa normal ekleme yap
        await addItem(variantId, null, null, product.handle)
      }
      publish(EVENTS.drawerOpen)

      // Drawer açılana kadar kısa bir süre bekle
      setTimeout(() => {
        btn.classList.remove('button--loading')
        btn.disabled = false
      }, 600)
    } catch (error) {
      console.error('Sepete ekleme hatası:', error)
      btn.classList.remove('button--loading')
      btn.disabled = false
    }
  });
  /* -------------------------
     WISHLIST REMOVE BUTTON
  -------------------------- */
  document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('.wishlist-remove, .wishlist-btn');
  if (!removeBtn) return;

  const card = removeBtn.closest('.wishlist-card');
  if (!card) return;

  const variantId = Number(card.dataset.variantId);

  Wishlist.set(
    Wishlist.get().filter(item => item.variantId !== variantId)
  );

  // 💥 ANINDA DOM'DAN SİL
  card.remove();

  // 📭 Empty state
  if (!Wishlist.get().length) {
    document.getElementById('wishlist-empty').hidden = false;
  }
  updateWishlistHeader()

    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  });

})();
const btnMobil = document.querySelector('.wishlist-mobil-area');

function onDOMReady(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn);
  } else {
    fn();
  }
}

function readyDOM(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn);
  } else {
    fn();
  }
}

readyDOM(() => {
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const variantId = Number(btn.dataset.variantId);
    if (window.Wishlist.has(variantId)) {
      btn.classList.add('active');
    }
  });
  updateWishlistHeader();
  
  const grid = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');

  // ❗ Bu sayfa wishlist değilse çık
  if (!grid) return;

  const items = window.Wishlist?.get() || [];

  if (!items.length) {
    if (empty) empty.hidden = false;
    return;
  }
  
  grid.innerHTML = items.reverse().map(item => `
    <div class="wishlist-card" data-variant-id="${item.variantId}">

      <!-- ❤️ Wishlist Button -->
      <button
        class="wishlist-btn active"
        aria-label="Favorilerden çıkar"
        data-variant-id="${item.variantId}"
        data-product='${JSON.stringify(item)}'>
      
        
        <svg class="heart-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12.1 20.3l-.1.1-.1-.1C7.1 16.2 4 13.4 4 9.9
               4 7.5 5.9 5.6 8.3 5.6
               c1.4 0 2.8.7 3.6 1.9
               .8-1.2 2.2-1.9 3.6-1.9
               2.4 0 4.3 1.9 4.3 4.3
               0 3.5-3.1 6.3-7.7 10.4z"
            fill="currentColor"
          />
        </svg>
      </button>

      <!-- 🖼 Image -->
      <a href="${item.variantId 
        ? `/products/${item.handle}?variant=${item.variantId}` 
        : `/products/${item.handle}`}" class="wishlist-image">
        <img src="${item.image}" alt="${item.title}" style="object-fit:contain">
      </a>

      <a href="${item.variantId 
        ? `/products/${item.handle}?variant=${item.variantId}` 
        : `/products/${item.handle}`}">
      <!-- ℹ️ Info -->
      <div class="wishlist-info">
        <h3 class="wishlist-title">
          ${
            item.plpProductTitle && item.kumas
              ? `${item.plpProductTitle} - ${item.kumas}`
              : item.title
          }
        </h3>

        ${item.variantTitle ? `
          <div class="wishlist-variant-title">
            ${item.variantTitle}
          </div>
        ` : ''}

        <div class="wishlist-price">${item.price}</div>
      </div>

      </a>
      <!-- 🛒 Add to cart -->
      <button
        type="button"
        class="wishlist-add-to-cart"
        data-variant-id="${item.variantId}"
        data-available="${item.availableStatus}"
        ${item.availableStatus ? '' : 'disabled'}>
        ${item.availableStatus ? 'Sepete Ekle' : 'Tükendi'}
      </button>
    </div>
  `).join('');
});

// function getConfgTitle(){
//   const container = document.querySelector("#shopify-section-product-template-configurator > section > div > div.product-block-list.product-block-list--large > div > div.product-block-list__item.product-block-list__item--info > div > div.card__section > sugar-shopify-variant").shadowRoot.querySelector("div");

//   const result = Array.from(container.querySelectorAll('section'))
//     .map(section => {
//       const checkedEl = section.querySelector('.checked');
//       return checkedEl ? checkedEl.innerText.trim() : null;
//     })
//     .filter(Boolean)
//     .join(' / ');

//   return result;
// }
function getConfgTitle(){
  
  const variantElement =
    document.querySelector(
      '#shopify-section-product-template-configurator sugar-shopify-variant'
    ) ||
    document.querySelector(
      '#shopify-section-product-template-new-configurator sugar-shopify-variant'
    );

  const container = variantElement?.shadowRoot?.querySelector('div');

  const result = Array.from(container.querySelectorAll('section'))
    .map(section => {
      const checkedEl = section.querySelector('.checked');
      if(!checkedEl) return null;

      if(
        checkedEl.htmlFor.includes('arm') ||
        checkedEl.htmlFor.includes('ct') ||
        checkedEl.htmlFor.includes('sizeType') ||
        checkedEl.htmlFor.includes('fabricType')
      ){
        console.log(checkedEl)
        return null;
      } else {
       return checkedEl.innerText.trim();
      }

    })
    .filter(Boolean)
    .join(' / ');

  return result;
}